module.exports = __webpack_public_path__ + "gg.svg?cfca4d1d56a7247865d787046bf0f23e";